import { Button } from "components";
import { useFormContext, useWatch } from "react-hook-form";
import { FormType } from "../../schemas";
import { mapDataSubmitSingle } from "../../functions";
import { useListFilter } from "../../stores";
import toast from "react-hot-toast";
import { useApi } from "utils";
import { PERMISION } from "security";

export function Update({ rowIndex, refecth }: { rowIndex: number, refecth?: () => void }) {

    // hooks
    const api = useApi()

    const { control } = useFormContext<FormType>();
    const { filter } = useListFilter();

    const rowData = useWatch({
        control,
        name: `detail.${rowIndex}`
    });

    
    

    const handleUpdateRow = () => {
        const mapData = mapDataSubmitSingle({
            rowData: rowData,
            end_date: filter.date_end,
            start_date: filter.date_start
        });

        const finalData = {
            ...mapData,
            shift_schedule: {
                ...mapData.shift_schedule,
                trx_code: filter.shift_schedule_code,
            },
            shift_schedule_detail: mapData.shift_schedule_detail.filter((item: any) => item.mr_shift_id !== null)
        }

        return new Promise<void>((resolve) => {
            toast.promise(
                api.post("/employee/save_data_schedule", finalData),
                {
                    loading: "Loading...",
                    success: (res) => res.data.message,
                    error: (err) => {
                        if (err.response.data.detail) {
                            return err.response.data.detail.message
                        }
                        return err.response.data.message
                    }
                }
            ).then(() => {
                refecth && refecth();
            }).catch(() => { }).finally(resolve)
        })

    }

    return (
        <Button
            permission={PERMISION.CARDS.REGISTER.SCHEDULE.UPDATE}
            color="primary"
            onClick={handleUpdateRow}
        >
            UPDATE
        </Button>
    )
}